import { ExtendedSubscription } from 'interfaces/subscription'

export const DEFAULT_SUBSCRIPTION: ExtendedSubscription = {
  type: null,
  provider: null,
  recommended_amount: '3.00',
  amount: '0',
  stripe: null,
  native: null,
  next_billing_date: null,
  cancel_date: null,
  can_be_cancelled: false,
}
